import React from 'react'

import { View } from 'react-native'

interface SpaceHProps {
  size?: number;
}

const SpaceH: React.FC<SpaceHProps> = ({ size = 10 }) => {
  return <View style={{ height: size }} />
}

export default SpaceH
